// extracted by mini-css-extract-plugin
module.exports = {"card":"marking-area_card__gvMYq","icon":"marking-area_icon__MXVuL"};